export default __webpack_public_path__ + "static/media/contact_background.f0e2c8f9.jpg";